import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Settings } from '~/Api/User/RoMaxPriceSettings';
import { flashSuccessMessage } from '~/FlashMessage';
import { fetchUserSettings, updateUserSettings } from '~/RoMaxPrice/actions';
import { UserSettings as UserSettingsState } from '~/RoMaxPrice/reducer';
import { State, ThunkDispatch } from '~/Store';
import { Breadcrumbs, BreadcrumbsItem } from '~/UI/Breadcrumbs';
import Heading from '~/UI/Heading';

import { Form, FormValues } from './Form';
import styles from './styles.less';

const mapFormValues = (settings: Settings | null): FormValues => ({
	exportAnnex1: {
		address: settings?.exportAnnex1.address ?? '',
		companyName: settings?.exportAnnex1.companyName ?? '',
		contactPersonName: settings?.exportAnnex1.contactPersonName ?? '',
		email: settings?.exportAnnex1.email ?? '',
		phone: settings?.exportAnnex1.phone ?? '',
		representativeName: settings?.exportAnnex1.representativeName ?? '',
		signedName: settings?.exportAnnex1.signedName ?? '',
	},
});

export const UserSettings: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
	const [settingsState, isUpdating] = useSelector<State, [UserSettingsState | null, boolean]>((state) => [
		state.roMaxPrice.userSettings,
		state.roMaxPrice.userSettingsUpdateRequest !== null,
	]);
	const [values, setValues] = React.useState<FormValues | null>(null);
	const currentValues = React.useMemo(
		() => values ?? mapFormValues(settingsState?.settings ?? null),
		[settingsState, values]
	);

	// TODO: Add correct type
	const dispatch = useDispatch<ThunkDispatch<any>>();
	React.useEffect(() => {
		dispatch(fetchUserSettings());
	}, []);

	const save = async () => {
		await dispatch(updateUserSettings(currentValues));
		dispatch(flashSuccessMessage('Settings successfully saved'));
	};
	const disabled = (settingsState?.isFetching ?? false) || isUpdating;

	return (
		<section className={styles.section}>
			<Breadcrumbs>
				<BreadcrumbsItem to='/'>Search</BreadcrumbsItem>
				<BreadcrumbsItem to='/profile/'>User profile</BreadcrumbsItem>
				<BreadcrumbsItem>Romania Max Price export settings</BreadcrumbsItem>
			</Breadcrumbs>

			<div className={styles.in}>
				<div className={styles.profileSection}>
					<Heading>Romania Max Price export settings</Heading>
				</div>

				<Form disabled={disabled} values={currentValues} onChange={setValues} onSubmit={save} />
			</div>
		</section>
	);
};
